/**
 * Even search filter types
 */
export enum EventSearchSortType {
  MODIFIED = <any>'MODIFIED',
  CREATED = <any>'CREATED',
  COMPLETED = <any>'COMPLETED'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/dashboard/event-search-sort-type-enum.ts